export default function getBadges(patient) {
  const patientIsMyGPIntegrated = patient.integrations?.some(
    (integration) => integration.name === 'my-gp'
  );

  const patientIsCegedimIntegrated = patient.integrations?.find(
    (integration) => integration.name === 'cegedim'
  );

  const patientIsERDIntegrated = patient.integrations?.some(
    (integration) => integration.name === 'electronic_repeat_dispensing'
  );

  return {
    commissionable: Boolean(patient.commissionable),
    nhsIntegrated: Boolean(patient.nhs_integrated || patient.nhs_id),
    managedPatient: Boolean(patient?.managed_patient),
    patientIsMyGPIntegrated,
    patientIsCegedimIntegrated,
    patientIsERDIntegrated,
  };
}
